import { ChargingStationStatus } from "@models/chargingStationStatus";

export class ChargingStationStatusHistoryDto {
  chargingStationId: string;
  chargingStationName: string;
  connectorId: number;

  statusId: number;
  status: ChargingStationStatus;

  displayStatus: string;

  timestamp: Date;

  getPrimaryKey() {
    return this.chargingStationId;
  }
}
